import authRules from '../authRules';

const approveTours = (user) => {
  const { approveTours } = user.securityLevels;
  if (approveTours >= authRules.approveTours.approveTours) {
      return true;
  } else {
      return false;
    }
  }

export default approveTours;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/approveTours.js